import { createActionGroup, props } from '@ngrx/store';

export const PoaSelectPaymentMethodAutopayActions = createActionGroup({
  source: 'POA Select Payment Method Component Autopay',
  events: {
    'Check Autopay Eligibility': props<{
      tenantId: string;
      accountNumbers: string[];
    }>(),
  },
});
